// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2NDAI","content":"footer_content__1Lyla","title":"footer_title__mjUW3","info":"footer_info__2KquG","nav":"footer_nav__1dKHx"};